export class TeamStatsModel {
  lastWeekAnswered = '0';
  lastWeekChanged = '0';
  lastMonthAnswered = '0';
  lastMonthChanged = '0';
  totalAnswered = '0';
  totalChanged = '0';
}
